import Vue from "vue";

export default Vue.extend({
  template: `<a :href="foo" @click.stop.prevent="clickHandler()" class="text-blue-500 hover:text-blue-800" >
    {{params.value}}
  </a>`,
  data: function() {
    return {
      class: "text-blue-500 hover:text-blue-800"
    };
  },
  beforeCreate() {},
  beforeMount() {},
  computed: {
    foo() {
      return this.params.to ?? "";
    }
  },
  mounted() {
    this.class = this.getClass();
  },
  methods: {
    getClass() {
      return this.params.class ? this.params.class : this.class;
    },
    clickHandler() {
      // call parent.clicked function
      this.params.clicked(this.params.value);
    }
  }
});
